import { render, staticRenderFns } from "./TabInfo.vue?vue&type=template&id=89dd9f90&scoped=true"
import script from "./TabInfo.vue?vue&type=script&lang=ts"
export * from "./TabInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dd9f90",
  null
  
)

export default component.exports